import { Divider } from "@mui/material";
import Grid from "@mui/material/Grid2";
import FormField from "./form-field";
import { useSearch } from "./search-context";
import { fieldConfig } from "./field-config";
import { SearchFieldErrors } from "./types";
import useValidateFormData from "./validation/validator";

interface QuickSearchFormProps {
  errors: SearchFieldErrors;
  resetErrors: () => void;
}

const QuickSearchForm = ({ errors, resetErrors }: QuickSearchFormProps) => {
  const form = useSearch();
  const validateForm = useValidateFormData();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    form.updateFormData({ [name]: value });
    validateForm();

    if (value.trim()) {
      resetErrors();
    }
  };

  return (
    <form data-testid="quick-search-form">
      <Grid container spacing={2} rowSpacing={3}>
        {fieldConfig.map((field) => {
          if (field.divider) {
            return (
              <Grid key={`divider-${field.name}`} size={{ xs: 12 }}>
                <Divider
                  textAlign="right"
                  sx={{
                    marginY: 1,
                    fontSize: "0.7rem",
                    color: "text.secondary",
                  }}
                >
                  <strong> Note:</strong> You must fill in at least one of the
                  optional fields below
                </Divider>
              </Grid>
            );
          }

          return (
            <Grid key={field.name} size={{ xs: 12, sm: field.size }}>
              <FormField
                label={field?.label}
                name={field?.name}
                value={form[field?.name as keyof typeof form]?.toString() ?? ""}
                onChange={handleChange}
                required={field.required}
                error={
                  field.name === "claimReference"
                    ? errors.claimRefErr
                    : field.optional && errors.requiredFieldErr
                }
                endIcon={field.icon}
              />
            </Grid>
          );
        })}
      </Grid>
    </form>
  );
};

export default QuickSearchForm;
